import _regeneratorRuntime from "/Users/yamilnunezaguirre/Clientes/delta/front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import { gapi, gapiComplete } from './gapiScript';

var loadAuth2 = function loadAuth2(clientId, scopes) {
  return _regeneratorRuntime.async(function loadAuth2$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return", new Promise(function (resolve) {
            gapi.load('auth2', function () {
              resolve(gapi.auth2.init({
                client_id: clientId,
                scope: scopes
              }));
            });
          }));

        case 1:
        case "end":
          return _context.stop();
      }
    }
  });
};

var loadAuth2WithProps = function loadAuth2WithProps(props) {
  return _regeneratorRuntime.async(function loadAuth2WithProps$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          return _context2.abrupt("return", new Promise(function (resolve) {
            gapi.load('auth2', function () {
              resolve(gapi.auth2.init(props));
            });
          }));

        case 1:
        case "end":
          return _context2.stop();
      }
    }
  });
};

export { gapi, gapiComplete, loadAuth2, loadAuth2WithProps };